module.exports = __webpack_public_path__ + "static/media/home_right_half_circle.2685562c.svg";